import React, { forwardRef } from "react";
import { Button as ChakraButton } from "@chakra-ui/react";
import styled, { useTheme } from "styled-components";

import { colors } from "@permisso/permisso-components";

type ButtonVariants = "solid" | "outline" | "ghost" | "danger";
interface ButtonProps {
  onClick: () => void;
  text: string;
  leftIcon?: React.ReactElement;
  rightIcon?: React.ReactElement;
  isLoading?: boolean;
  disabled?: boolean;
  variant?: ButtonVariants;
  fitContent?: boolean;
  dataTestId?: string;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      onClick,
      text,
      leftIcon,
      rightIcon,
      disabled = false,
      isLoading = false,
      variant = "solid",
      fitContent = false,
      dataTestId,
    },
    ref,
  ) => {
    const { blackColor } = useTheme();
    const outlineStyles =
      variant === "outline"
        ? {
            backgroundColor: colors.grey0,
            color: blackColor,
            borderColor: colors.grey500,
            _hover: { backgroundColor: colors.grey400, color: blackColor, boxShadow: "none" },
          }
        : {};

    return (
      <StyledButton
        ref={ref}
        data-testid={dataTestId}
        variant={variant}
        onClick={onClick}
        leftIcon={leftIcon}
        rightIcon={rightIcon}
        isDisabled={disabled}
        iconSpacing={2}
        isLoading={isLoading}
        $fitContent={fitContent}
        borderRadius={8}
        {...outlineStyles}
      >
        {text}
      </StyledButton>
    );
  },
);

const StyledButton = styled(ChakraButton)<{ $fitContent: boolean }>`
  padding: 0 1.5rem;
  font-weight: 500;
  border-radius: 0.5rem !important;
  width: ${({ $fitContent }) => ($fitContent ? "fit-content" : "100%")};
  min-width: 10rem !important;
`;
